import React from 'react'
import { connect } from 'react-redux'
import * as actions from '../../actions'
import { OperacionesCupoAsignadoView } from '../../components/asignacionCupos/OperacionesCupoAsignadoView'

function OperacionesCupoAsignado (props) {
  const { cupo } = props

  return (
    <OperacionesCupoAsignadoView
      cupo={cupo}
      openDialogModificacion={props.openDialogModificacion}
      deleteCupo={props.deleteCupo}
      bloquearCupos={props.bloquearCupos}
      cambiarEstadoHabilitadoCupo={props.cambiarEstadoHabilitadoCupo}
      openDialogNominacion={props.openDialogNominacion}
    />
  )
}
export default connect(null, actions)(OperacionesCupoAsignado)
